import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { layout, spacing } from 'styles/constants';

export const Container = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [styles.container, isDesktop ? styles.containerDesktop : styles.containerMobile, style],
  });
};

export const Title = withTypography({
  m: '$0',
  style: { textTransform: 'capitalize' },
});

export const StyledText = withTypography({
  m: '$0',
  textAlign: 'center',
});

export const ButtonContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [
      styles.buttonContainer,
      isDesktop ? styles.buttonContainerDesktop : styles.buttonContainerMobile,
      style,
    ],
  });
};

const styles = StyleSheet.create({
  buttonContainer: {
    alignItems: 'center',
    marginTop: spacing.$4,
  },
  buttonContainerDesktop: {
    width: 300,
  },
  buttonContainerMobile: {
    width: '80%',
  },
  container: {
    alignItems: 'center',
    width: layout.full,
  },
  containerDesktop: {
    marginBottom: spacing.$8,
    marginTop: '5%',
  },
  containerMobile: {
    marginTop: '50%',
  },
});
